import {
  getMainOrderStatus,
  getSecondaryStatus,
  getAllSuppliers,
  getAllCompanies,
  getAllSavedSearch,
  getAllViewBatchList,
  getBatchProcessSavedSearch,
  getSavedSearchById,
  addBatchProcessSaveSearch,
  editBatchProcess,
  removeBatchById,
  updateBatchProcessFile,
} from "@/api/divvy-batchProcess";
import moment from "moment";

const batchProcess = {
  namespaced: true,
  state: () => ({
    Days: [
      {
        text: "1 Day",
        values: 1,
      },
      {
        text: "2 Day",
        values: 2,
      },
      {
        text: "3 Day",
        values: 3,
      },
      {
        text: "4 Day",
        values: 4,
      },
      {
        text: "5 Day",
        values: 5,
      },
      {
        text: "6 Day",
        values: 6,
      },
      {
        text: "7 Day",
        values: 7,
      },
      {
        text: "10 Day",
        values: 10,
      },
      {
        text: "20 Day",
        values: 20,
      },
      {
        text: "30 Day",
        values: 30,
      },
      {
        text: "60 Day",
        values: 60,
      },
      {
        text: "All Day",
        values: 1000,
      },
    ],
    searchAndBatchFlag: [
      { useSavedSearchFlag: true },
      { viewBatchFlag: false },
    ],
    mainOrderStatus: [],
    secondaryStatus: [],
    allSuppliers: [],
    allCompanies: [],
    savedSearches: [],
    orderStatus: [],
    exportFileType: [
      { text: "No export", value: false },
      { text: "Excel spreadsheet", value: true },
    ],
    viewBatchPagination: {
      pageNo: 1,
      pageSize: 3,
      totalRecords: 0,
      totalPoints: 0,
      totalDollars: 0,
      selectedRecordCount: 0,
      sortField: "",
      sortOrder: "",
    },
    viewBatchStoreParams: {},
    viewBatchStoreParamsAll: {},
    viewBatchOrderList: [],
    filterRecordsPerScreenOptions: [
      {
        value: 3,
        text: "3",
      },
      {
        value: 5,
        text: "5",
      },
      {
        value: 10,
        text: "10",
      },
      {
        value: 50,
        text: "50",
      },
      {
        value: 100,
        text: "100",
      },
    ],
    savedSearchObject: {
      name: "",
      id: null,
    },
    batchProcessSavedSearchList: [],
    batchProcessSavedSearchPagination: {
      pageNo: 1,
      pageSize: 3,
      totalRecords: 0,
      selectedRecordCount: 0,
      sortField: "",
      sortOrder: "",
    },
    batchProcessSavedSearchDaysBack: 2,
    batchProcessViewBatchSaveSearchObj: {
      title: "Test 1",
      form_packet: {
        version: "1.0",
        header: "",
        data: {
          struct: {
            var: [
              {
                key: "ExportOptions",
                value: "",
              },
              {
                key: "SBEGINDATE",
                value: "",
              },
              {
                key: "SEARCHFORM",
                value: "true",
              },
              {
                key: "SDAYSBACK",
                value: "0",
              },
              {
                key: "searchTitle",
                value: "",
              },
              {
                key: "RTNRECORDAMT",
                value: "500",
              },
              {
                key: "setMasterStatus",
                value: "",
              },
              {
                key: "SGIFT",
                value: "0",
              },
              {
                key: "setInvoiceNum",
                value: "",
              },
              {
                key: "invoiceNum",
                value: "",
              },
              {
                key: "INCLUDEORDER",
                value: "1",
              },
              {
                key: "setDateProc",
                value: "",
              },
              {
                key: "SSTATUSCODE",
                value: "",
              },
              {
                key: "SBATCHNUM",
                value: "",
              },
              {
                key: "SSUPPLIER",
                value: "",
              },
              {
                key: "SENDDATE",
                value: "",
              },
              {
                key: "dateHandled",
                value: "",
              },
              {
                key: "GETBATCH",
                value: "View batch",
              },
              {
                key: "SINVOICENUM",
                value: "",
              },
              {
                key: "batchlabel",
                value: "",
              },
              {
                key: "SDATETYPE",
                value: "1",
              },
              {
                key: "FIELDNAMES",
                value:
                  "SMASTERSTATUS,SSTATUSCODE,SDAYSBACK,SBATCHNUM,SBEGINDATE,SENDDATE,SDATETYPE,SORDERNUM,SINVOICENUM,SBILLINGCODE,SSUPPLIER,SCOMPANY,GETBATCH,SRCH_ID,SEARCHFORM",
              },
              {
                key: "SORDERNUM",
                value: "",
              },
              {
                key: "SBILLINGCODE",
                value: "",
              },
              {
                key: "SMASTERSTATUS",
                value: "",
              },
              {
                key: "SCOMPANY",
                value: "0",
              },
              {
                key: "SRCH_ID",
                value: "",
              },
              {
                key: "SETBATCHNUMBER",
                value: "0",
              },
            ],
          },
        },
      },
    },
    viewBatchUpdateMessage: {},
    viewBatchMessage: {
      message: "",
      color: "",
    },
    batchMessage: {
      message: "",
      color: "",
    },
    tableStatus: "No records found",
    isBatchProcessSaveSearchRedirect: {
      redirect: false,
      showOrderDetails: {
        batchNumber: "",
        createdDate: "",
        handleDate: "",
        batchName: "",
      },
    },
  }),
  getters: {
    getAllDays: (state) => state.Days,
    getSavedSearchAndViewBatchFlag: (state) => state.searchAndBatchFlag,
    getMainOrderStatusArr: (state) => state.mainOrderStatus,
    getSecondaryStatusArr: (state) => state.secondaryStatus,
    getAllSuppliersArr: (state) => state.allSuppliers,
    getAllCompaniesArr: (state) => state.allCompanies,
    getSavedSerches: (state) => state.savedSearches,
    getOrderStatus: (state) => state.orderStatus,
    getExportFileType: (state) => state.exportFileType,
    getViewBatchPagination: (state) => state.viewBatchPagination,
    getViewBatchStoreParams: (state) => state.viewBatchStoreParams,
    getViewBatchStoreParamsAll: (state) => state.viewBatchStoreParamsAll,
    getViewBatchOrderList: (state) => state.viewBatchOrderList,
    getFilterRecordsPerScreenOptions: (state) =>
      state.filterRecordsPerScreenOptions,
    getSavedSearchObject: (state) => state.savedSearchObject,
    getBatchProcessSavedSearchList: (state) =>
      state.batchProcessSavedSearchList,
    getBatchProcessSavedSearchPagination: (state) =>
      state.batchProcessSavedSearchPagination,
    getBatchProcessSavedSearchDaysBack: (state) =>
      state.batchProcessSavedSearchDaysBack,
    getBatchProcessViewBatchSaveSearchObj: (state) =>
      state.batchProcessViewBatchSaveSearchObj,
    getViewBatchUpdateMessage: (state) => state.viewBatchUpdateMessage,
    getViewBatchMessage: (state) => state.viewBatchMessage,
    getBatchMessage: (state) => state.batchMessage,
    getTableStatus: (state) => state.tableStatus,
    getIsBatchProcessSaveSearchRedirection: (state) =>
      state.isBatchProcessSaveSearchRedirect,
  },
  actions: {
    fetchMainOrderStatus({ commit }) {
      return new Promise((resolve, reject) => {
        getMainOrderStatus()
          .then((status) => {
            commit("SET_MAIN_ORDER_STATUS", status);
          })
          .catch((err) => {
            console.log(err, "from fetch main order status");
          });
      });
    },
    fetchSecondaryStatus({ commit }) {
      return new Promise((resolve, reject) => {
        getSecondaryStatus()
          .then((status) => {
            commit("SET_SECONDARY_STATUS", status);
          })
          .catch((err) => {
            console.log(err, "from fetch secondary status");
          });
      });
    },
    fetchAllSuppliers({ commit }) {
      return new Promise((resolve, reject) => {
        getAllSuppliers()
          .then((suppliers) => {
            commit("SET_ALL_SUPPLIERS", suppliers);
          })
          .catch((err) => {
            console.log(err, "from fetch all suppliers");
          });
      });
    },
    fetchAllCompanies({ commit }) {
      return new Promise((resolve, reject) => {
        getAllCompanies()
          .then((companies) => {
            commit("SET_ALL_COMPANIES", companies);
          })
          .catch((err) => {
            console.log(err, "from fetch all companies");
          });
      });
    },
    fetchAllSavedSearch({ commit }) {
      return new Promise((resolve, reject) => {
        getAllSavedSearch()
          .then((savedSearches) => {
            commit("SET_SAVED_SEARCHES", savedSearches);
          })
          .catch((err) => {
            console.log(err, "from fetch all saved search");
          });
      });
    },
    fetchAllViewBatchList({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getAllViewBatchList(payload)
          .then((batchOrders) => {
            if (batchOrders.status === 200) {
              commit(
                "SET_ALL_VIEW_BATCH_LIST",
                batchOrders.data.Result ? batchOrders.data.Result : []
              );
              commit("SET_VIEW_BATCH_PAGINATION", {
                pageNo: batchOrders.data.pageNumber,
                pageSize: batchOrders.data.pageSize,
                totalRecords: batchOrders.data.totalRecords,
                totalPoints: batchOrders.data.totalPoints,
                totalDollars: batchOrders.data.totalDollars,
                selectedRecordCount: batchOrders.data.selectedRecordCount,
                sortField: batchOrders.data.sortField,
                sortOrder: batchOrders.data.sortOrder,
              });
              commit("SET_VIEW_BATCH_MESSAGE", {
                message: "Showing view batches",
                color: "#00d5a5",
              });
            } else {
              commit("SET_ALL_VIEW_BATCH_LIST", []);
              commit("SET_VIEW_BATCH_PAGINATION", {
                pageNo: 1,
                pageSize: 3,
                totalRecords: 0,
                totalPoints: 0,
                totalDollars: 0,
                selectedRecordCount: 0,
                sortField: "",
                sortOrder: "",
              });
              commit("SET_VIEW_BATCH_MESSAGE", {
                message: "Something went wrong",
                color: "red",
              });
            }
            resolve();
          })
          .catch((err) => {
            console.log(err, "from fetch all view batch list");
          });
      });
    },
    fetchBatchProcessSavedSearch({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getBatchProcessSavedSearch(payload)
          .then((searches) => {
            if (searches.status === 200) {
              commit(
                "SET_BATCH_PROCESS_SAVED_SEARCH_LIST",
                searches.data.Result ? searches.data.Result : []
              );
              commit("SET_BATCH_PROCESS_SAVED_SEARCH_PAGINATION", {
                pageNo: searches.data.pageNumber,
                pageSize: searches.data.pageSize,
                totalRecords: searches.data.totalRecords,
                selectedRecordCount: searches.data.selectedRecordCount,
                sortField: searches.data.sortField,
                sortOrder: searches.data.sortOrder,
              });
              commit("SET_VIEW_BATCH_MESSAGE", {
                message: "Showing recent batches",
                color: "#00d5a5",
              });
            } else {
              commit("SET_BATCH_PROCESS_SAVED_SEARCH_LIST", []);
              commit("SET_BATCH_PROCESS_SAVED_SEARCH_PAGINATION", {
                pageNo: 1,
                pageSize: 3,
                totalRecords: 0,
                selectedRecordCount: 0,
                sortField: "",
                sortOrder: "",
              });
              commit("SET_VIEW_BATCH_MESSAGE", {
                message: "Something went wrong",
                color: "red",
              });
            }
            resolve();
          })
          .catch((err) => {
            console.log(err, "from fetch batch process saved search list");
          });
      });
    },
    fetchSavedSearchById({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getSavedSearchById(payload)
          .then((searches) => {
            if (searches.status === 200) {
              commit("SET_VIEW_BATCH_STORE_PARAMS_ALL", searches.data);
              commit("SET_VIEW_BATCH_MESSAGE", {
                message: "Used save search",
                color: "#00d5a5",
              });
            } else {
              commit("SET_VIEW_BATCH_STORE_PARAMS_ALL", {});
              commit("SET_VIEW_BATCH_MESSAGE", {
                message: "Something went wrong",
                color: "red",
              });
            }
            resolve();
          })
          .catch((err) => {
            console.log(err, "from fetch all saved search by id store");
          });
      });
    },
    batchProcessSaveSearch({ commit }, payload) {
      return new Promise((resolve, reject) => {
        addBatchProcessSaveSearch(payload)
          .then((output) => {
            if (output.status === 200) {
              commit("SET_VIEW_BATCH_MESSAGE", {
                message: "Saved search successfully",
                color: "#00d5a5",
              });

              var params = {
                order_status_code: "",
                batch_number: "",
                order_number: "",
                secondary_status_code: "",
                start_date: "",
                end_date: "",
                invoice_number: "",
                days_back: 0,
                unhandled_orders_only: false,
                billing_code: "",
                supplier_ids: [],
                company_ids: [],
              };
              commit("SET_VIEW_BATCH_STORE_PARAMS", params);
            } else {
              commit("SET_VIEW_BATCH_MESSAGE", {
                message: "Something went wrong",
                color: "red",
              });
            }
            resolve();
          })
          .catch((err) => {
            console.log(err, "from batch process save search store");
          });
      });
    },
    updateBatchProcess({ commit }, payload) {
      return new Promise((resolve, reject) => {
        editBatchProcess(payload)
          .then((output) => {
            if (output.status === 200) {
              var creatingMsgString = "";

              if (output.data.batch_number) {
                creatingMsgString += `New batch [${output.data.batch_number}] created<br> `;
              }
              if (output.data.invoice_number) {
                creatingMsgString += `Invoice number [${output.data.invoice_number}] updated<br> `;
              }
              if (output.data.date_handled) {
                creatingMsgString += `Date handled set to ${moment(
                  output.data.date_handled
                ).format("MM/DD/YYYY")}<br> `;
              }
              if (output.data.status) {
                creatingMsgString += `Order status set to ${output.data.status}<br> `;
              }

              commit("SET_BATCH_MESSAGE", {
                message: creatingMsgString,
                color: "#00d5a5",
              });
            } else {
              commit("SET_BATCH_MESSAGE", {
                message: "Something went wrong",
                color: "red",
              });
            }
            resolve();
          })
          .catch((err) => {
            console.log(
              err,
              "from batch process save search editBatchProcess store"
            );
          });
      });
    },
    deleteBatchById({ commit }, payload) {
      return new Promise((resolve, reject) => {
        removeBatchById(payload)
          .then((output) => {
            if (output.status === 200) {
              commit("SET_BATCH_MESSAGE", {
                message:
                  "Batch " + payload.batchNumber + " Successfully deleted",
                color: "#00d5a5",
              });
            } else {
              commit("SET_BATCH_MESSAGE", {
                message: "Something went wrong",
                color: "red",
              });
            }
            resolve();
          })
          .catch((err) => {
            console.log(err, "from batch process deleteBatchById store");
          });
      });
    },
    updateBatchProcessFileExport({ commit }, payload) {
      return new Promise((resolve, reject) => {
        updateBatchProcessFile(payload)
          .then((file) => {
            if (file.status === 200) {
              commit("SET_BATCH_MESSAGE", {
                message: "File downloaded successfully",
                color: "#00d5a5",
              });

            } else if(file.status === 400) {
              commit("SET_BATCH_MESSAGE", {
                message: "Please Create a batch first",
                color: "red",
              });
            } 
            else {
              commit("SET_BATCH_MESSAGE", {
                message: "Something went wrong",
                color: "red",
              });
            }
            resolve(file);
          })
          .catch((err) => {
            console.log(
              err,
              "from batch process updateBatchProcessFileExport store"
            );
          });
      });
    },
  },
  mutations: {
    SET_MAIN_ORDER_STATUS: (state, payload) => {
      state.mainOrderStatus = payload;
    },
    SET_SECONDARY_STATUS: (state, payload) => {
      state.secondaryStatus = payload;
    },
    SET_ALL_SUPPLIERS: (state, payload) => {
      state.allSuppliers = payload;
    },
    SET_ALL_COMPANIES: (state, payload) => {
      state.allCompanies = payload;
    },
    SET_SAVED_SEARCHES: (state, payload) => {
      state.savedSearches = payload;
    },
    SET_ORDER_STATUS: (state, payload) => {
      state.orderStatus = payload;
    },
    SET_VIEW_BATCH_STORE_PARAMS: (state, payload) => {
      state.viewBatchStoreParams = payload;
    },
    SET_ALL_VIEW_BATCH_LIST: (state, payload) => {
      state.viewBatchOrderList = payload;
    },
    SET_VIEW_BATCH_PAGINATION: (state, payload) => {
      state.viewBatchPagination = payload;
    },
    SET_SAVED_SEARCH_OBJECT: (state, payload) => {
      state.savedSearchObject = payload;
    },
    SET_ALL_VIEW_BATCH_LIST: (state, payload) => {
      state.viewBatchOrderList = payload;
    },
    SET_BATCH_PROCESS_SAVED_SEARCH_LIST: (state, payload) => {
      state.batchProcessSavedSearchList = payload;
    },
    SET_BATCH_PROCESS_SAVED_SEARCH_PAGINATION: (state, payload) => {
      state.batchProcessSavedSearchPagination = payload;
    },
    SET_BATCH_PROCESS_SAVED_SEARCH_DAYS_BACK: (state, payload) => {
      state.batchProcessSavedSearchDaysBack = payload;
    },
    SET_VIEW_BATCH_STORE_PARAMS_ALL: (state, payload) => {
      state.viewBatchStoreParamsAll = payload;
    },
    SET_VIEW_BATCH_UPDATE_MESSAGE: (state, payload) => {
      state.viewBatchUpdateMessage = payload;
    },
    SET_VIEW_BATCH_MESSAGE: (state, payload) => {
      state.viewBatchMessage = payload;
    },
    SET_BATCH_MESSAGE: (state, payload) => {
      state.batchMessage = payload;
    },
    SET_TABLE_STATUS: (state, payload) => {
      state.tableStatus = payload;
    },
    SET_BATCH_PROCESS_IS_SAVE_SEARCH_REDIRECT: (state, payload) => {
      state.isBatchProcessSaveSearchRedirect = payload;
    },
  },
};

export default batchProcess;
